/**
 * @module PriceSearch
 * @author Created by yanghongmei1
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';

import CityItem from '../cityPicker/cityItem';
import ProvinceItem from '../cityPicker/provinceItem';
import { JDScrollView } from '@jdreact/jdreact-core-lib';

import { pt } from '../../../../components/utiles';
const l3All = [{name: '全部', tradingAreaId: 0}]
const compareObj = (obj, allObj, type)=> {
    const minKey = 'min'+type
    const maxKey = 'max'+type
    if (allObj[minKey] == obj.min && allObj[maxKey] == obj.max) {
        return true
    } else if (allObj[minKey] == obj.min && (!allObj[maxKey] && !obj.max)) {
        return true
    } else {
        return false
    }
}
const formatNowIndex = (obj)=> {
    if (obj.minTradePrice) {
        return 2
    } else {
        return 1
    }
}

export default class PriceSearch extends PureComponent {
    static defaultProps = {
        name: 'PriceSearch',
        customStyle: {},
        searchObj: {},
        pageId: '',
        AllPriceList: [],
        RentPriceList: [],
        talkParams: () => {} // 第一个参数是选择的list,第二个参数是传递过来的tabIndex(当前组件在大搜索中的index)没有就不回传
    }

    constructor(props) {
        super(props);
        
        this.state = {
            nowPageIndex: formatNowIndex(this.props.searchObj),
            mySearchObj: this.props.searchObj,
            // l3List: this.props.cityData.find(l1 => l1.thirdCode === this.props.searchObj.countyId)? l3All.concat(l1.childList) : []
        };
    }

    componentDidMount() {
        
    }
    _resetClick = () => {
        this.setState({
            mySearchObj: {
                minRentPrice: '',
                maxRentPrice:'',
                minTradePrice: '',
                maxTradePrice: ''
            }
        })
    }

    _AllOkClick = () => {
        const { mySearchObj } = this.state;
        this.props.talkParams(mySearchObj);
    }
    FristClick = (item) => {
        const {nowPageIndex} = this.state
        if (nowPageIndex === item.id) return
        this.setState({
            nowPageIndex: item.id,
        },()=>{this._resetClick()})
    };

    PriceClick= (item, type) => {
        const {mySearchObj} = this.state
        if (compareObj(item, mySearchObj,type)) {
            this.setState({
                mySearchObj: {
                    minRentPrice: '',
                    maxRentPrice:'',
                    minTradePrice: '',
                    maxTradePrice: ''
                }
            })
        } else {
            if (type === 'RentPrice') {
                this.setState({
                    mySearchObj: {
                        minRentPrice: item.min,
                        maxRentPrice: item.max,
                        minTradePrice: '',
                        maxTradePrice: ''
                    }
                })
            } else {
                this.setState({
                    mySearchObj: {
                        minRentPrice: '',
                        maxRentPrice:'',
                        minTradePrice: item.min,
                        maxTradePrice: item.max
                    }
                })
            }
            
        }
        
    };

    render() {
        const {
            RentPriceList,
            AllPriceList
        } = this.props;
        // 是否展示级联选择
        
        const { nowPageIndex, mySearchObj } = this.state;
        const l1List = [{name:'租金',id: 1},{name:'售价',id: 2}]
        return (
            <View style={styles.container}>
                <View style={styles.cityPickerContainer}>
                    <View style={styles.container_com}>
                        <View style={styles.level1Container}>
                            <JDScrollView >
                                {l1List.map((item, index) => {
                                    return (
                                        <ProvinceItem
                                            title={item.name}
                                            key={index+'_l1List'}
                                            isSelected={nowPageIndex === item.id}
                                            onSelect={() => {this.FristClick(item)}}
                                        />
                                    );
                                })}
                            </JDScrollView>
                        </View>
                        {nowPageIndex === 1 && <View style={styles.recommendWrapper}>
                            <View style={styles.level2Container}>
                                    <JDScrollView>
                                        {RentPriceList.length > 0 && RentPriceList.map((item, index) => {
                                            return (
                                                <CityItem
                                                    title={item.name}
                                                    key={index+'_RentPriceList'}
                                                    isSelected={compareObj(item, mySearchObj,'RentPrice')}
                                                    isMultiSelect={true}
                                                    unitStr = {index === 0 ? '元/m²以下' : index === RentPriceList.length - 1 ? '元/m²以上' : '元/m²'}
                                                    onSelect={() => {
                                                        this.PriceClick(item,'RentPrice');
                                                    }}
                                                />
                                            );
                                        })}
                                    </JDScrollView>
                                </View>
                        </View>}
                        {nowPageIndex === 2 && <View style={styles.recommendWrapper}>
                            <View style={styles.level2Container}>
                                    <JDScrollView>
                                        {AllPriceList.length > 0 && AllPriceList.map((item, index) => {
                                            return (
                                                <CityItem
                                                    title={item.name}
                                                    key={index+'_AllPriceList'}
                                                    isSelected={compareObj(item, mySearchObj,'TradePrice')}
                                                    isMultiSelect={true}
                                                    onSelect={() => {
                                                        this.PriceClick(item,'TradePrice');
                                                    }}
                                                />
                                            );
                                        })}
                                    </JDScrollView>
                                </View>
                        </View>}
                    </View>
                </View>
            </View>
        );
    }
}

PriceSearch.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.array,
    searchObj: PropTypes.object,
    customStyle: PropTypes.any,
    talkParams: PropTypes.func
};

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    cityPickerContainer: {
        width: '100%',
        height: '100%',
        backgroundColor: '#fff'
    },
    container_com: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 1
    },
    level1Container: {
        flexDirection: 'column',
        width: pt(170),
        backgroundColor: '#F6F6F6',
        height: '100%'
    },
    level2Container: {
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        // overflow: 'scroll',
        backgroundColor: '#fff'
    },
    level3Container: {
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        // overflow: 'scroll',
        backgroundColor: '#fff',
        borderLeftColor: '#ccc',
        borderLeftWidth: pt(1)
    },
    cascadeContainer: {
        height: '100%',
        flexDirection: 'row',
        flex: 1
    },
    recommendWrapper: {
        height: '100%',
        flex: 1
    }
});
